<script>
    import { createEventDispatcher } from 'svelte';
    import Icon from '../icons/Icon.svelte';

    export let show = false;
    export let selectedTable = null;
    export let tables = [];
    export let customerName = '';
    export let peopleCount = 2;

    const dispatch = createEventDispatcher();

    function handleClose() {
        dispatch('close');
    }

    function handleConfirm() {
        dispatch('confirm');
    }
</script>

{#if show && selectedTable}
    <div class="modal-overlay">
        <div class="modal-card">
            <div class="modal-header">
                <div class="modal-title-wrap">
                    <span class="modal-pretitle">Atendimento Presencial</span>
                    <h3>Abrir {selectedTable.label}</h3>
                </div>
                <button class="close-btn" on:click={handleClose}><Icon name="x" size={16} /></button>
            </div>
            <div class="modal-body">
                {#if tables.filter(t => t.status === 'available').length > 1}
                    <div class="field">
                        <label for="open-table-select">Mesa do Salão:</label>
                        <select id="open-table-select" bind:value={selectedTable}>
                            {#each tables.filter(t => t.status === 'available') as t}
                                <option value={t}>{t.label} ({t.seats} lugares)</option>
                            {/each}
                        </select>
                    </div>
                {/if}
                <div class="field">
                    <label for="open-name">Nome do Cliente ou Referência (Opcional):</label>
                    <input 
                        id="open-name" 
                        type="text" 
                        placeholder="Ex: Família Silva, Carlos, Casal" 
                        bind:value={customerName} 
                    />
                </div>
                <div class="field">
                    <label for="open-people">Número de Pessoas:</label>
                    <input 
                        id="open-people" 
                        type="number" 
                        min="1" 
                        max="30"
                        bind:value={peopleCount} 
                    />
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn-cancel" on:click={handleClose}>Cancelar</button>
                <button class="btn-primary" on:click={handleConfirm}>
                    <Icon name="check" size={14} />
                    <span>Abrir Mesa & Lançar Itens</span>
                </button>
            </div>
        </div>
    </div>
{/if}

<style>
    .modal-overlay {
        position: fixed;
        inset: 0;
        background: rgba(15, 23, 42, 0.6);
        backdrop-filter: blur(4px);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
        animation: fadeIn 0.15s ease-out;
    }

    @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
    }

    .modal-card {
        background: #FFFFFF;
        border-radius: 16px;
        width: 90%;
        max-width: 440px;
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
        display: flex;
        flex-direction: column;
        overflow: hidden;
        border: 1px solid #E2E8F0;
        animation: slideUp 0.2s cubic-bezier(0.16, 1, 0.3, 1);
    }

    @keyframes slideUp {
        from { transform: translateY(12px) scale(0.98); opacity: 0; }
        to { transform: translateY(0) scale(1); opacity: 1; }
    }

    .modal-header {
        padding: 16px 20px;
        border-bottom: 1px solid #E2E8F0;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .modal-title-wrap {
        display: flex;
        flex-direction: column;
        gap: 2px;
    }

    .modal-pretitle {
        font-size: 11px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        color: #FF6A00;
    }

    .modal-header h3 {
        margin: 0;
        font-size: 16px;
        font-weight: 800;
        color: #0F172A;
    }

    .close-btn {
        background: transparent;
        border: none;
        color: #64748B;
        cursor: pointer;
        padding: 6px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.15s ease;
    }

    .close-btn:hover {
        background: #F1F5F9;
        color: #0F172A;
    }

    .modal-body {
        padding: 20px;
        display: flex;
        flex-direction: column;
        gap: 14px;
    }

    .field {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .field label {
        font-size: 12.5px;
        font-weight: 700;
        color: #334155;
    }

    .field select,
    .field input {
        width: 100%;
        padding: 9px 12px;
        background: #F8FAFC;
        border: 1.5px solid #CBD5E1;
        border-radius: 8px;
        font-size: 13.5px;
        color: #0F172A;
        box-sizing: border-box;
        transition: all 0.2s ease;
    }

    .field select:focus,
    .field input:focus {
        outline: none;
        background: #FFFFFF;
        border-color: #FF6A00;
        box-shadow: 0 0 0 3px rgba(255, 106, 0, 0.12);
    }

    .modal-footer {
        padding: 14px 20px;
        border-top: 1px solid #E2E8F0;
        display: flex;
        justify-content: flex-end;
        gap: 10px;
        background: #F8FAFC;
    }

    .btn-cancel {
        padding: 9px 16px;
        background: #FFFFFF;
        border: 1.5px solid #CBD5E1;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 700;
        color: #475569;
        cursor: pointer;
        transition: all 0.2s ease;
    }

    .btn-cancel:hover {
        background: #F1F5F9;
        color: #0F172A;
    }

    .btn-primary {
        padding: 9px 18px;
        background: #FF6A00;
        border: 1.5px solid #FF6A00;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 800;
        color: #FFFFFF;
        cursor: pointer;
        box-shadow: 0 2px 4px rgba(255, 106, 0, 0.2);
        transition: all 0.2s ease;
        display: inline-flex;
        align-items: center;
        gap: 6px;
    }

    .btn-primary:hover {
        background: #E65F00;
        border-color: #E65F00;
        box-shadow: 0 4px 8px rgba(255, 106, 0, 0.3);
    }
</style>
